import useApi from "./useApi";

/**
 * useDriverAssignments hook
 * @param {Object} options
 * @param {Object} options.query - Optional query params (e.g., order_id, status, driver_id)
 * @param {number} options.page - Page number for pagination
 * @param {number} options.perPage - Items per page for pagination
 */
const useDriverAssignments = ({ query = {}, page = 1, perPage = 20 } = {}) => {
  const { get } = useApi();
  const endpoint = "/admin/driver-assignments-view";
  
  // Add query params if provided
  const params = { ...query, page, per_page: perPage };
  const queryString = Object.keys(params).length
    ? "?" + new URLSearchParams(params).toString()
    : "";
  
  const { data, isLoading, error } = get(endpoint + queryString);

  // Extract the assignments array from the API response
  const assignments = data?.data?.data || [];
  const pagination = data?.data || {};

  return { assignments, pagination, isLoading, error };
};

export default useDriverAssignments;
